import { t } from "i18next";
import { useState } from "react";
import { DateInput, Input, Modal } from "ui";

import styles from "./AddHolidayModal.module.scss";

interface Props {
  isOpen: boolean;
  isSaving?: boolean;
  onClose: () => void;
  onSubmit: (name: string, date: Date) => void;
}

const AddHolidayModal = ({ isOpen, isSaving, onClose, onSubmit }: Props) => {
  const [date, setDate] = useState<Date | null>(null);
  const [name, setName] = useState("");

  const reset = () => {
    setDate(null);
    setName("");
  };

  const handleClose = () => {
    reset();
    onClose();
  };

  const isValid = Boolean(date && name.trim());

  const onOk = () => {
    if (!date || !isValid) return;
    onSubmit(name.trim(), date);
    reset();
  };

  return (
    <Modal
      isOpen={isOpen}
      title={t("Add holiday date")}
      okText="Add date"
      cancelText="Cancel"
      onOk={onOk}
      isOkDisabled={!isValid}
      isLoading={isSaving}
      contentClassName={styles.content}
      onClose={handleClose}
    >
      <div className={styles.form}>
        <DateInput label={t("Date")} value={date} onChange={setDate} />
        <Input
          label={t("Name")}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t("e.g. Independence Day")}
        />
      </div>
    </Modal>
  );
};

export default AddHolidayModal;
